import {
  Grid,
  Typography,
  Paper,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  cardLabel: {
    fontSize: 11,
    fontWeight: 400,
    lineHeight: '70%',
    letterSpacing: '1.5px'
  },
  cardValue: {
    fontSize: 20,
    fontWeight: 500,
    letterSpacing: '0.15px'
  },
}));

export const ItemDisplay = ({
  label,
  value,
  alignItems = 'center',
}) => {
  const classes = useStyles();
  return (
    <Grid
      container
      alignItems={alignItems as any}
      justifyContent="center"
      direction="column"
    >
      <Grid item>
        <Typography variant="body2" className={classes.cardValue}>
          {value}
        </Typography>
      </Grid>
      <Grid item>
        <Paper
          elevation={0}
          style={{ textAlign: 'center', backgroundColor: 'transparent' }}
        >
          <Typography variant="body2" className={classes.cardLabel}>
            {label}
          </Typography>
        </Paper>
      </Grid>
    </Grid>
  );
};